[...document.querySelectorAll('.notification[data-show-until]')].forEach(notification => {
  const showUntil = parseInt(notification.getAttribute('data-show-until'), 10)
  const now = Date.now() / 1000

  if (!Number.isNaN(showUntil) && showUntil < now) {
    notification.remove()
  }
})
